import { makeStyles } from '@material-ui/core/styles';
import { SortableElement } from 'react-sortable-hoc';

import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/RemoveCircleOutline';

import Table from 'components/CncUI/Table';
import Priority from '../Priority';
import DragHandle from './DragHandle';
import Field from './Field';

import EnumHelper from 'utilities/enumHelper';

const useStyles = makeStyles(({ palette }) => ({
  row: {
    backgroundColor: palette.cncUI.default['+10'],
  },
  remove: {
    color: palette.cncUI.alert.red.primary,
  },
}));

const Row = props => {
  const classes = useStyles();
  const { value: item, mappings, form, amountType, sortIndex } = props;
  const { onRemove, onChange, multiple, error, isCurrencyEnabled } = props;

  return (
    <Table.Row className={classes.row}>
      {multiple && (
        <Table.Cell>
          <DragHandle />
        </Table.Cell>
      )}
      {multiple && (
        <Table.Cell align="center">
          <Priority>{sortIndex + 1}</Priority>
        </Table.Cell>
      )}
      <Table.Cell>{item.bankName || ''}</Table.Cell>
      <Table.Cell>
        {EnumHelper.valueToOptionLabel(
          mappings.bankAccountTypes,
          item.bankAccountType,
        ).replace(' Account', '')}
      </Table.Cell>
      <Table.Cell>{item.routingNumber}</Table.Cell>
      <Table.Cell>{item.bankAccountNumber}</Table.Cell>
      <Table.Cell>
        {item.primary ? (
          form.length <= 1 ? (
            'Full Amount'
          ) : multiple ? (
            'Remainder'
          ) : (
            'Full Amount'
          )
        ) : multiple ? (
          <Field
            item={form[sortIndex]}
            index={sortIndex}
            error={error}
            type={amountType}
            onChange={onChange}
            currency={item.currencyType || 'US'}
            isCurrencyEnabled={isCurrencyEnabled}
          />
        ) : (
          ' '
        )}
      </Table.Cell>
      <Table.Cell align="right">
        <IconButton onClick={() => onRemove(sortIndex)}>
          <DeleteIcon fontSize="small" className={classes.remove} />
        </IconButton>
      </Table.Cell>
    </Table.Row>
  );
};

export default SortableElement(Row);
